import { Injectable, Injector } from '@angular/core';
import { GuardResult, Router, RouterStateSnapshot } from '@angular/router';
import { CmsActivatedRouteSnapshot, CmsService, PageContext, RoutingService } from '@spartacus/core';
import {
  CmsComponentsService,
  CmsGuardsService,
  CmsI18nService,
  CmsPageGuardService as CxCmsPageGuardService,
} from '@spartacus/storefront';
import { Observable, of, tap } from 'rxjs';
import { Page } from '../../core/cms';
import { SemanticPathService } from '../../core/routing';
import { BaseSiteService } from '../../core/site-context';
import { prepareUrlForLink } from '../../core/util';
import { CmsRoutesService } from '../services/cms-routes.service';
import { INTERNAL_STATUS } from '../../core/model';
import { WindowRef } from '../../core/window';

/**
 * Helper service for `CmsPageGuard`
 */
@Injectable({
  providedIn: 'root',
})
export class CmsPageGuardService extends CxCmsPageGuardService {
  constructor(
    protected semanticPathService: SemanticPathService,
    protected cmsService: CmsService,
    protected cmsRoutes: CmsRoutesService,
    protected cmsI18n: CmsI18nService,
    protected cmsGuards: CmsGuardsService,
    protected cmsComponentsService: CmsComponentsService,
    protected routing: RoutingService,
    protected router: Router,
    protected baseSiteService: BaseSiteService,
    protected injector: Injector
  ) {
    super(semanticPathService, cmsService, cmsRoutes, cmsI18n, cmsGuards, cmsComponentsService, routing);
  }

  canActivatePage(
    pageContext: PageContext,
    pageData: Page,
    route: CmsActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<GuardResult> {
    if (this.baseSiteService.isFallback()) {
      if (state.url !== '/') {
        const urlTree = this.router.parseUrl(prepareUrlForLink('/'));
        return of(urlTree);
      }
    }
    return super.canActivatePage(pageContext, pageData, route, state).pipe(
      tap((result: GuardResult) => {
        if (!this.injector.get(WindowRef).isBrowser()) {
          const notFoundLabel = this.semanticPathService.get('notFound');
          if (result === true && notFoundLabel === pageData.label) {
            this.injector.get(INTERNAL_STATUS).code = 404;
          }
        }
      })
    );
  }
}
